import React from "react"
import { useEffect, useState } from "react"
import { Ridecell } from "@ridecell/web-sdk"
import {
  JumboCard,
  Typography,
  Box,
  Icons,
  withStyles,
} from "@ridecell/web-components-material"
import { injectIntl } from "react-intl"

import Backdrop from "@material-ui/core/Backdrop"
import CircularProgress from "@material-ui/core/CircularProgress"
import styles from "../styles"
import useCurrentLocation from "../../../../utils/customHooks/useCurrentLocation"
import messages from "../messages"

const AxeptaHostedPage = ({
  classes,
  intl: { formatMessage },
  onClose,
  customerId,
  handleNext,
  headerNeeded = true,
}) => {
  const [url, setUrl] = useState(null)
  const [loader, setLoader] = useState(false)
  const { location } = useCurrentLocation()

  const iframe = document.getElementById("axepta-iframe")

  useEffect(() => {
    ;(async () => {
      try {
        setLoader(true)
        const resp = await Ridecell.getAxeptaHostedPage({
          customerId: customerId,
          data: {
            type: "CIT_WITH_COF_URL",
            ...(location && { lat: location.lat }),
            ...(location && { lng: location.lng }),
          },
        })
        setUrl(resp.url)
      } catch (e) {
        //show error
      } finally {
        setLoader(false)
      }
    })()
  }, [])

  document.body.addEventListener(
    "DOMNodeRemoved",
    function (evt) {
      var removedNode = evt && evt.target
      if (removedNode === iframe) {
        if (onClose) onClose()
        handleNext()
      }
    },
    false
  )

  return (
    <React.Fragment>
      {url && (
        <JumboCard
          className={classes.axeptaCard}
          flexDirection="row"
          header={false}
          last={false}
        >
          {headerNeeded && (
            <Box display="flex" justifyContent="space-between" pb={"20px"}>
              <Typography variant="body1" style={{ fontWeight: 600 }}>
                {formatMessage(messages.addCard)}
              </Typography>
              <Icons.Cancel onClick={onClose} style={{ cursor: "pointer" }} />
            </Box>
          )}
          <Box height="60vh">
            {url && (
              <iframe
                id="axepta-iframe"
                title="axepta"
                src={url}
                width={"100%"}
                height={"100%"}
              />
            )}
          </Box>
        </JumboCard>
      )}
      <Backdrop className={classes.loadingBackdrop} open={loader}>
        <CircularProgress style={{ color: "white" }} />
      </Backdrop>
    </React.Fragment>
  )
}

export default withStyles(styles)(injectIntl(AxeptaHostedPage))
